/* eslint-disable @typescript-eslint/no-explicit-any */
import { GeneratedZorroPy, ZorroPyClientFactory } from '@zorro/clients';
import { NextApiRequest, NextApiResponse } from 'next';

import { withApiSession } from './session';

export type ZorroPyEndpointCall = {
  method: string;
  params: unknown[];
  impersonatedEmployeeId?: string;
};

export async function zorroPyClientHandler(
  req: NextApiRequest,
  res: NextApiResponse
) {
  await withApiSession(req, res, async (_monolithClient, logger, session) => {
    try {
      const { method, params, impersonatedEmployeeId } =
        req.body as ZorroPyEndpointCall;

      const isAgentMethod =
        method in GeneratedZorroPy.AgentShoppingConsultantService.prototype;

      const zorroPyClient = isAgentMethod
        ? ZorroPyClientFactory.getAgentShoppingConsultant({
            accessToken: session.accessToken,
            impersonatedEmployeeId,
          })
        : ZorroPyClientFactory.getInstance({
            accessToken: session.accessToken,
          });

      const response = await (zorroPyClient as any)[method](...params);
      res.status(200).json(response);
    } catch (error) {
      logger.error(error, 'ZorroPy API call failed');
      res.status(error.status || 500).json(error);
    }
  });
}
